const BusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="24"
            height="24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6.8 2C5.119 2 4 3.119 4 4.8V17.6c0 1.681 1.119 2.8 2.8 2.8H7.2a2 2 0 004 0h1.6a2 2 0 004 0h.4c1.681 0 2.8-1.119 2.8-2.8V4.8C20 3.119 18.881 2 17.2 2H6.8zM7 6h10v5H7V6z"
            />
        </svg>
    );
};

export default BusIcon;
